import { ContentLink } from "@components/Link/ContentLink";
import { navigationTracker } from "@components/navigation/NavigationTracker";

import { FactsStructure } from "types/FactsStructure";
import { IAmStructureItem } from "types/IAmStructureItem";

type FactBreadcrumbsData = {
  url: string;
  text: string;
};
export const getFactsBreadCrumbsData = (
  factsStructure: FactsStructure,
  currentSlugs: string[],
): FactBreadcrumbsData[] => {
  const breadCrumbItems = new Array<FactBreadcrumbsData>();

  if (!factsStructure?.flatStructure?.length && !currentSlugs?.length) return [];
  else {
    breadCrumbItems.push({
      url: "/forsakringshandboken",
      text: "Försäkringshandboken",
    });
    for (const slug of currentSlugs) {
      let foundStructureItem = {} as IAmStructureItem;
      foundStructureItem = factsStructure?.flatStructure?.filter(
        (factsItem) => factsItem.slug === slug,
      )[0];
      if (!foundStructureItem) return;

      breadCrumbItems.push({
        url: foundStructureItem?.url,
        text: foundStructureItem?.name,
      });
    }
  }

  return breadCrumbItems;
};

export const getFactsStructureBreadCrumbs = (factBreadcrumbs: FactBreadcrumbsData[]): any[] => {
  const breadCrumbItems = [];

  factBreadcrumbs?.map((factBreadcrumb, index) =>
    breadCrumbItems.push(
      <ContentLink
        href={`${factBreadcrumb?.url}`}
        onClick={() =>
          navigationTracker(factBreadcrumb?.text, "Utbildning och material", "breadcrumbs")
        }
        noTracking={true}
        aria-current={index === factBreadcrumbs?.length - 1 ? "page" : undefined}
        contentText={factBreadcrumb?.text}
      >
        {factBreadcrumb?.text}
      </ContentLink>,
    ),
  );

  return breadCrumbItems;
};
